// How many open alerts a tab has, shown beside its name (Admin sub-tabs). Documents counts them
// all, as its "Needs attention" list does; Sources only the source ones.

import { isSourceAlert } from "@ask-hr/core/alerts";
import { useAlerts } from "./NeedsAttention.js";

export function AlertCounts({ tab }: { tab: "documents" | "sources" }) {
  const [alerts] = useAlerts();
  const n = (alerts ?? []).filter((a) => tab === "documents" || isSourceAlert(a)).length;
  return n ? (
    <span className="tab-count" aria-label={`${n} need attention`}>
      {n}
    </span>
  ) : null;
}
